import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { StyledRow } from "./styledrow.styles";
import { Cell } from "../cell/cell";
export function Row({ onChange, record, primaryKey, type, odd, baseColumns = [], columnsKey, index, checked, onClick, }) {
    const [focused, setFocused] = useState(false);
    return (_jsx(StyledRow, Object.assign({ className: `${record.disabled ? "disabled" : ""} ${record.readonly ? "readonly" : ""}`, checked: checked, tabIndex: type === "TB01" || type === "TB03" ? -1 : 0, onMouseDown: () => setFocused(false), onKeyUp: (e) => e.key === "Tab" && setFocused(true), onBlur: () => setFocused(false), onClick: () => {
            if (type === "TB04") {
                onClick(record);
            }
            else if (type === "TB02") {
                onChange(record[primaryKey], `checkbox`);
            }
        }, onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === "Space" || e.key === " ") {
                if (type === "TB04") {
                    onClick(record);
                }
                else if (type === "TB02") {
                    onChange(record[primaryKey], `checkbox`);
                }
            }
        }, focused: focused, rowType: "body", odd: odd, tableType: type }, { children: baseColumns.map((column, colIndex) => {
            const { render, dataIndex: dIndex, align, width, font } = column;
            const key = columnsKey[colIndex];
            let additionalCellProps;
            if (column.onCell) {
                additionalCellProps = column.onCell(record, index);
            }
            return (_jsx(Cell, { font: font, width: width, additionalProps: additionalCellProps, record: record, dataIndex: dIndex, index: index, render: render, align: align, colSpan: column.colSpan, tableType: type, rowType: "body", sortIcon: false }, key));
        }) })));
}
